module.exports = __webpack_public_path__ + "static/media/notice.32094349.png";